import {Component, computed, input} from '@angular/core';
import {UIChart} from 'primeng/chart';
import {ChartOptions} from 'chart.js';
import {buildChapterProgressChartData} from './chapter-progress-ring.utils';

const DOUGHNUT_CUTOUT_PERCENT = '80%';
const RING_SIZE_PX = 56;

@Component({
  selector: 'app-chapter-progress-ring',
  imports: [UIChart],
  templateUrl: './chapter-progress-ring.component.html',
})
export class ChapterProgressRingComponent {
  label = input.required<string>();
  totalSteps = input.required<number>();
  completedSteps = input.required<number>();
  inProgressSteps = input.required<number>();

  protected readonly ringSizePx = RING_SIZE_PX;

  protected readonly chartData = computed(() =>
    buildChapterProgressChartData(this.totalSteps(), this.completedSteps(), this.inProgressSteps()),
  );

  protected readonly chartOptions: ChartOptions<'doughnut'> = {
    cutout: DOUGHNUT_CUTOUT_PERCENT,
    responsive: false,
    plugins: {
      legend: {display: false},
      tooltip: {enabled: false},
    },
  };
}
